// extracted by mini-css-extract-plugin
export var videoContainer = "_j2-0";
export var videoIframe = "_j2-3";
export var videoLink = "_j2-1";
export var videoOverlay = "_j2-4";
export var videoOverlayText = "_j2-5";
export var videoWrapper = "_j2-2";